/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import { AuthConsumer } from "../../AuthContext";
import PlugLanding from "../PlugLanding/PlugLanding";
import copyEn from "../PlugLanding/copyEn";

/**
 * The Plug marketing site in English. All markup lives in PlugLanding; this
 * only picks the language.
 */
class PlugEn extends Component {
  render() {
    return (
      <AuthConsumer>
        {({ i18n }) => <PlugLanding {...this.props} copy={copyEn} lang="en" i18n={i18n} />}
      </AuthConsumer>
    );
  }
}

export default PlugEn;
